<template>

    <router-view></router-view>

</template>


<script>


export default {
    name: 'Empty Layout',
    data() {
        return {
        }
    },
    components: {
    },
    async created(){

    },
    async mounted() {

      
    },
    beforeUnmount() {
       
    },
    watch: {
       
    },
    methods: {

       
        Nolink(){
            alert("available soon");
        }

    }

}
</script>
